import {Component} from '@angular/core';
import {MatDialogContent, MatDialogRef} from "@angular/material/dialog";
import {ModalHeaderComponent} from '../../../layout/modal-header/modal-header.component';
import {PrettyPrintJsonComponent} from '../../../components/pretty-print-json/pretty-print-json.component';
import {JsonVisualizerComponent} from "../../../components/json-visualizer/json-visualizer.component";

@Component({
    selector: 'app-info-unwrap-object',
    templateUrl: './info-unwrap-object.component.html',
    styleUrls: ['./info-unwrap-object.component.scss'],
  imports: [ModalHeaderComponent, MatDialogContent, JsonVisualizerComponent]
})
export class InfoUnwrapObjectComponent {
  objectBefore = {
    _item: {
      name: 'Datamorf',
      email: 'info@onionos.io',
      type: 'company'
    }
  }
  objectAfter = {
    name: 'Datamorf',
    email: 'info@onionos.io',
    type: 'company'
  }
  constructor(
    public dialogRef: MatDialogRef<InfoUnwrapObjectComponent>,
  ) { }

}
